<template>
  <button v-bind="$attrs" type="button" role="button" :title="title"
          class="button-base btn share btn-lg d-flex justify-content-start align-items-center"
          @click="$emit('click')">
    <slot name="icon">
      <img :src="iconPath" class="share-icon" :class="`${medium}-icon`">
    </slot>
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  props: {
    iconFilename: {
      type: String,
      required: false
    },

    label: {
      type: String,
      required: false
    },

    medium: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    }
  },

  emits: ['click'],

  computed: {
    iconPath() {
      const filename = this.iconFilename || `${this.medium}.svg`
      return require(`@/images/icons/${filename}`)
    },

    text() {
      return this.label || this.i18n.t(`public.social.share_on_${this.medium}`)
    }
  }
}
</script>

<style scoped lang="scss">
  @use "~common_styles/breakpoints" as breakpoints;

  .button-base {
    text-transform: unset;
  }

  ::v-deep(.share-icon) {
    width: 22px;
  }

  span {
    text-align: left;

    @include breakpoints.screen-md-only {
      font-size: 1rem;
    }
  }
</style>
